<template>
    <div class="education-favorites row py-lg-5">
        <div v-if="educations.length === 0 && noResults" class="col-12">
            <span>{{ noResults }}</span>
        </div>

        <EducationCard
            v-for="education in educations"
            :key="education.id"
            v-model="selectedEducations"
            class="col-12 col-lg-4 pb-2"
            :education="education"
            :is-favorites-page="true"
        ></EducationCard>

        <div
            class="education-favorites__selected d-flex justify-content-between align-items-center flex-wrap"
            data-aos="education-favorites-resize"
            data-aos-anchor=".navbar__aos-tracker"
            data-aos-offset="0"
        >
            <i class="fas fa-file-pdf mr-1"></i>
            <span class="mr-1"
                >Geselecteerde opleidingen:
                <strong> {{ numberOfSelectedEducations }}</strong>
            </span>
            <button class="btn btn-small" @click="downloadPdfs">
                download
            </button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EducationCard from '@/components/education/education-card';

export default {
    components: {
        EducationCard
    },

    data() {
        return {
            educations: [],
            favorites: [],
            selectedEducations: [],
            noResults: ''
        };
    },
    computed: {
        numberOfSelectedEducations() {
            return this.selectedEducations.length;
        }
    },
    created() {
        this.getFavoritesFromStore();
        this.getEducations();
    },

    methods: {
        getFavoritesFromStore() {
            this.favorites = this.$store.getters.getAllFavorites;
        },

        getEducations() {
            if (this.favorites.length) {
                axios({
                    method: 'get',
                    url:
                        '/api/EducationApi/GetFavoriteEducations?ids=' +
                        this.favorites
                })
                    .then(response => {
                        if (!response.data === null) {
                            return false;
                        }
                        this.educations = this.educations.concat(response.data);

                        return true;
                    })
                    .catch(() => false);
            } else {
                axios({
                    method: 'get',
                    url: '/api/EducationApi/GetEmptyFavorites'
                })
                    .then(response => {
                        if (!response.data === null) {
                            return false;
                        }

                        this.noResults = response.data;

                        return true;
                    })
                    .catch(() => false);
            }
        },

        downloadPdfs() {
            window.open(
                '/pdf/GeneratePagesToPDF?ids=' + this.selectedEducations,
                '_blank'
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.education-favorites__selected {
    position: fixed;
    bottom: 82px;
    right: 0;
    background-color: $color-blue;
    width: 100%;
    padding: 1rem;
    color: white;
    z-index: 50;

    i {
        font-size: 1.375rem;
    }

    @include media-breakpoint-up(md) {
        width: auto;
    }
}
</style>
